var _style, _defs, _rect, _defs2, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalentouLogoNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 734.1 260.3",
    style: {
      enableBackground: "new 0 0 734.1 260.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000183938057916949048030000008140467763433389952_);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000114775236264382243530000012709409828380216729_);}\n\t.st3{fill:#A3E28F;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M44.8,79h-44V55.2h111.7V79h-44v121.1H44.8V79z M113.3,194.6c-8.1-5-12.1-13.3-12.1-24.9 c0-7.4,1.8-13.6,5.5-18.7c3.7-5.1,8.5-8.9,14.5-11.4s12.4-3.8,19.2-3.8c8,0,15.2,1.4,21.5,4.1v-12.3c0-4.9-2.1-8.7-6.2-11.4 c-4.2-2.7-9.2-4.1-15.2-4.1c-4.5,0-8.8,0.7-12.9,2.2s-7.4,3.7-10,6.7l-12.7-13.1c5.3-5.9,11.1-9.9,17.3-12.3 c6.2-2.3,13.1-3.5,20.6-3.5s14,1.3,20.4,3.9c6.3,2.6,11.5,6.5,15.4,11.8s5.9,11.7,5.9,19.3V195c-5.5,2.1-11.7,3.8-18.7,5.1 s-14.1,2.1-21.4,2.1C131.7,202.1,121.4,199.6,113.3,194.6L113.3,194.6z M162,181v-23.5c-2.3-1.1-5.1-2-8.4-2.7 c-3.3-0.7-6.5-1-9.8-1c-6.4,0-11.4,1.4-15,4.3s-5.4,6.7-5.4,11.4s1.9,8.1,5.6,10.3c3.8,2.2,8.4,3.4,14,3.4 C149.6,183.3,156,182.5,162,181L162,181z M216.9,192.4c-7.2-6.5-10.7-15.4-10.7-26.7V55.2h22.5v110.4c0,4.5,1.6,8.2,4.7,11 c3.1,2.9,7.7,4.3,13.7,4.3v21.1C234.1,202.1,224.1,198.9,216.9,192.4L216.9,192.4z M280,157.5v7.4c0,4.6,1.9,8.4,5.6,11.1 c3.8,2.8,8.1,4.2,13.2,4.2c4.4,0,8.3-0.9,11.8-2.6c3.5-1.7,6.1-4.4,7.9-8.1l18.8,10.8c-4,6.9-9.4,12.3-16.5,16.1 s-14.2,5.6-21.6,5.6s-14-1.4-20.5-4.2c-6.4-2.8-11.6-6.9-15.5-12.4c-4-5.4-5.9-12.1-5.9-19.8v-37.2c0-7.9,2-14.6,5.9-20 c4-5.4,9.1-9.5,15.5-12.3c6.4-2.7,13.2-4.1,20.5-4.1s13.8,1.4,20,4.1c6.3,2.7,11.4,6.8,15.3,12.3c4,5.5,5.9,12.1,5.9,20v29 L280,157.5L280,157.5z M285.5,117.9c-3.8,2.7-5.7,6.4-5.5,11.4v9.6h38.9v-10c0-4.6-1.9-8.3-5.7-10.9s-8.4-4-13.7-4 S289.4,115.3,285.5,117.9z M376.8,94.5c6.3-1.5,12.6-2.3,19-2.4c13.2-0.1,24.3,2.9,33.2,9.1c8.9,6.2,13.4,15.7,13.4,28.5v70.4 h-22.3v-70.2c-0.3-5.6-2.7-9.8-7.2-12.6c-4.5-2.8-9.8-4.2-15.8-4.2s-11.2,1.2-15.1,3.7v83.3h-22.5v-99.4 C364.8,98.1,370.5,96,376.8,94.5L376.8,94.5z M490.2,175.8c2.1,2.5,4.8,4.2,8,4.9c3.2,0.8,7.3,1.1,12.4,1.1v19.6 c-2.9,0.4-5.7,0.6-8.4,0.6c-11.2,0-20.2-3.1-27.1-9.4c-6.9-6.3-10.3-15.8-10.3-28.4V69.1h20.2l2,24.9h20.2v20.4h-20L487,164 C487,169.4,488,173.3,490.2,175.8L490.2,175.8z M661.4,192.9c-7.8-6-11.8-15.2-11.8-27.6V94.1h22.5v71.6c0.3,5.6,2.6,9.8,7.1,12.7 c4.4,2.9,9.7,4.3,15.8,4.3c5.6,0,10.7-1.2,15.3-3.7V94.1h22.3v99.2c-6.5,2.7-13.3,4.9-20.3,6.4c-7,1.6-13.8,2.4-20.3,2.4 C679.4,202,669.2,198.9,661.4,192.9L661.4,192.9z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101074175451906603240000009924152061896683400_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000101074175451906603240000009924152061896683400_)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    className: "st1",
    width: 734.1,
    height: 260.3
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000060007547863803763060000015839213523153473722_",
    d: "M578.3,117.5c16.5,0,29.9,13.4,29.9,29.9 s-13.4,29.9-29.9,29.9s-29.9-13.4-29.9-29.9S561.9,117.5,578.3,117.5 M578.3,94.9c-29,0-52.4,23.5-52.4,52.4s23.5,52.4,52.4,52.4 s52.4-23.5,52.4-52.4S607.3,94.9,578.3,94.9L578.3,94.9z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060007547863803763060000015839213523153473722_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108267567313025622230000009289368720152063664_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060007547863803763060000015839213523153473722_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000108267567313025622230000009289368720152063664_)"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 11,
    className: "st1",
    width: 734.1,
    height: 238.4
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M578.3,128.8c-10.3,0-18.6,8.3-18.6,18.6s8.3,18.6,18.6,18.6s18.6-8.3,18.6-18.6S588.6,128.8,578.3,128.8 L578.3,128.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentouLogoNav);
export default __webpack_public_path__ + "static/media/Talentou-Logo-nav.12bdf51e06d462c09de1c7cec79e24a2.svg";
export { ForwardRef as ReactComponent };